<template>
    <div v-if="series">
        <CardRowText
            :label="$t('name-short')"
            :text="valueToString(series.nameShort)"
            :has-border-bottom="true"
            :has-copy-button="true"
        />
        <CardRowText
            :label="$t('name-long')"
            :text="valueToString(series.nameLong)"
            :has-border-bottom="true"
            :has-copy-button="true"
        />
        <CardRowText :label="$t('subtitle')" :text="valueToString(series.subtitle)" :has-border-bottom="true" />
        <CardRowAttachmentGroup
            v-if="websites.length > 0"
            :label="$t('event-series-websites')"
            :items="websites"
            :has-border-bottom="true"
        />
        <CardRowText v-else :label="$t('event-series-websites')" text="-" :has-border-bottom="true" />
        <CardRowText
            :label="$t('number-kapman')"
            :text="valueToString(series.numberKapman)"
            :help-text="$t('number-kapman-help')"
            :has-border-bottom="true"
        />
        <CardRowText
            :label="$t('number-short')"
            :text="valueToString(series.numberShort)"
            :help-text="$t('number-short-help')"
            :has-border-bottom="true"
        />
        <CardRowText
            :label="$t('foundation-year')"
            :text="valueToString(series.foundationYear?.toString())"
            :has-border-bottom="true"
        />
        <CardRowText :label="$t('notes')" :text="valueToString(series.notes)" :has-border-bottom="true" />
        <CardRowText :label="$t('description')" :text="valueToString(series.description)" :has-border-bottom="true" />
        <CardRowImage
            :label="$t('logo')"
            :label-hint="$t('img-hint-bigger-version')"
            :image-url="logoState === 'Processing' ? (pendingLogoUrl ?? '') : iconUrl"
            :image-alt="`Logo ${series.nameShort}`"
            :image-state="logoState"
            :has-border-bottom="false"
            :throw-on-image-error="false"
        />
    </div>
</template>
<script setup lang="ts">
import CardRowAttachmentGroup from '@/components/Card/CardRowAttachmentGroup.vue';
import CardRowImage from '@/components/Card/CardRowImage.vue';
import CardRowText from '@/components/Card/CardRowText.vue';
import { toCardRowAttachmentLink } from '@/components/MultiLink/multilink';
import { useEventSeries } from '@/event/composables/useEventSeries';
import { useEventSeriesInjection } from '@/event/composables/useEventSeriesInjection';
import { valueToString } from '@/forms/forms';
import { thumbnailUrl } from '@/utils/file';
import { computed } from 'vue';

const props = defineProps<{ seriesId: string }>();

const seriesId = computed(() => props.seriesId);
const { series } = useEventSeries(seriesId);
const { logoState, pendingLogoUrl } = useEventSeriesInjection();
const iconUrl = computed(() => thumbnailUrl(series.value?.icon, 'url128'));

const websites = computed(() => toCardRowAttachmentLink(series.value?.websites.links.nodes ?? []));
</script>
